export default __webpack_public_path__ + "static/media/RSRTC.6f31d4ad.jpg";